import React, { FC } from 'react';
import Icon from '@ant-design/icons';

export const FileUploadTwoTone: FC = props => <Icon component={FileUploadTwoToneSVG} {...props} />;

const FileUploadTwoToneSVG = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      opacity='0.4'
      d='M29.321 14.4533C29.2943 13.8133 29.1876 13.1866 28.9876 12.5866C28.0676 9.70665 25.3743 7.62665 22.201 7.62665H18.481C17.7076 7.62665 17.6543 7.54665 17.241 6.99998L15.3743 4.51998C14.5077 3.35998 13.8276 2.65332 11.6543 2.65332H8.54761C5.29427 2.65332 2.6543 5.29332 2.6543 8.54665V12.5733V22.1866C2.6543 26.12 5.85435 29.32 9.78768 29.32H22.1877C26.121 29.32 29.321 26.12 29.321 22.1866V14.7466C29.3343 14.6666 29.3343 14.5466 29.321 14.4533Z'
      fill='#007BFB'
    />
    <path
      d='M20.7741 26.2667C17.9607 26.4667 17.9607 30.5467 20.7741 30.7467H27.4541C28.2674 30.7467 29.0407 30.4534 29.6407 29.9067C31.614 28.1867 30.5607 24.72 27.9607 24.4C27.0273 18.7734 18.8807 20.9067 20.814 26.2667'
      fill='#007BFB'
    />
  </svg>
);
